<template>
    <div>
        <!-- :label="field.label" -->
        <b-form-group
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
            ><label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for="" -->
            <!-- >{{ field.label -->
            <!-- }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label" -->
            <!-- >({{ field.urduLabel }})</span -->
            <!-- ></label -->
            <!-- > -->
            <b-form-textarea
                id="textarea"
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :placeholder="field.placeholder"
                rows="3"
                max-rows="3"
                :disabled="loading || isDisable"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                    'is-invalid': isInvalid,
                }"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
export default {
    data() {
        return {
            isInvalid: '',
            isDisable: false,
        }
    },
    computed: {
        urduLabel() {
            if (this.$store.state.registration.form.languageOption == 'urd') {
                return true
            } else {
                return false
            }
        },
    },
    mounted() {
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason1') {
            this.isDisable = true

            if (
                this.$store.state.registration.form.crsInfo.crsReason1 ==
                'Unable to obtain a TIN/Equivalent Number '
            ) {
                // console.log(newValue)
                // console.log(this.field.status)
                this.isDisable = false
            } else {
                this.isDisable = true
                this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
            }
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason2') {
            this.isDisable = true

            if (
                this.$store.state.registration.form.crsInfo.crsReason2 ==
                'Unable to obtain a TIN/Equivalent Number '
            ) {
                // console.log(newValue)
                // console.log(this.field.status)
                this.isDisable = false
            } else {
                this.isDisable = true
                this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
            }
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason3') {
            this.isDisable = true

            if (
                this.$store.state.registration.form.crsInfo.crsReason3 ==
                'Unable to obtain a TIN/Equivalent Number '
            ) {
                // console.log(newValue)
                // console.log(this.field.status)
                this.isDisable = false
            } else {
                this.isDisable = true
                this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
            }
        } // End
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    created() {
        if (this.field.key == 'pepInfo.declarationPEP8') {
            this.isDisable = true
            // console.log(this.$store.state.registration.form.pepInfo)
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.pepInfo
                },
                (newValue, oldValue) => {
                    // console.log(newValue)
                    for (let key in newValue) {
                        if (newValue.hasOwnProperty(key)) {
                            // console.log(key + ' -> ' + newValue[key])
                            if (newValue[key] == 'Yes') {
                                this.field.isRequired = true
                                this.isInvalid = true
                                this.isDisable = false
                                break
                            } else {
                                this.field.isRequired = false
                                this.isInvalid = false
                                this.isDisable = true
                            }
                        }
                    }
                    // console.log(this.$store.state.registration.form.pepInfo)
                },
                {
                    deep: true,
                }
            )
        }

        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason1') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason1
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        // console.log(newValue)
                        // console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                        this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
                    }
                }
            )
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason2') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason2
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        // console.log(newValue)
                        // console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                        this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
                    }
                }
            )
        } // End
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'crsInfo.crsOtherReason3') {
            this.isDisable = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo
                        .crsReason3
                },
                (newValue) => {
                    if (
                        newValue == 'Unable to obtain a TIN/Equivalent Number '
                    ) {
                        // console.log(newValue)
                        // console.log(this.field.status)
                        this.isDisable = false
                    } else {
                        this.isDisable = true
                        this.$store.commit('updateField', {
                        key: this.field.key,
                        value: null,
                    })
                    }
                }
            )
        } // End
    },
}
</script>
